import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'attach_department_permission_tags';
export const useAttachDepartmentPermissionTagsTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Добавить',
    search_placeholder: 'Поиск',
    loading: 'Загрузка',
    load_more: 'Загрузить ещё',
    empty: 'Нет доступных тегов',
    load_error: 'Не удалось загрузить теги',
    on_success: 'Тег прикреплён',
    on_error: 'Не удалось прикрепить тег',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Add',
    search_placeholder: 'Search',
    loading: 'Loading',
    load_more: 'Load more',
    empty: 'No tags available',
    load_error: 'Failed to load tags',
    on_success: 'Tag attached',
    on_error: 'Failed to attach tag',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Agregar',
    search_placeholder: 'Buscar',
    loading: 'Cargando',
    load_more: 'Cargar más',
    empty: 'No hay etiquetas disponibles',
    load_error: 'No se pudieron cargar las etiquetas',
    on_success: 'Etiqueta adjuntada',
    on_error: 'No se pudo adjuntar la etiqueta',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Adicionar',
    search_placeholder: 'Pesquisar',
    loading: 'Carregando',
    load_more: 'Carregar mais',
    empty: 'Nenhuma tag disponível',
    load_error: 'Falha ao carregar as tags',
    on_success: 'Tag anexada',
    on_error: 'Falha ao anexar a tag',
  },
}) : {}) as Record<string, unknown>;
